import type { ElementType } from 'react';

import { Divider } from '@mui/material';

export interface CardIconProps {
  icon: ElementType;
}

const CardIcon = ({ icon: Icon }: CardIconProps) => (
  <>
    <Icon color="primary" sx={{ fontSize: 46 }} />

    <Divider flexItem />
  </>
);

export default CardIcon;
